import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-2",
  "use": "foquz-icon-rating-2-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" id=\"foquz-icon-rating-2\"><path d=\"M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11z\" fill=\"#F97F46\" /><path d=\"M14.645 15.567a5 5 0 00-7.071-.052\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" /><circle cx=\"7.5\" cy=\"8.5\" r=\"1.5\" fill=\"#fff\" /><circle cx=\"14.5\" cy=\"8.5\" r=\"1.5\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol